import * as actionTypes from './actionTypes';

export const getReservations = (start, count, loadMore) => {
    return {
        type: actionTypes.GET_RESERVATIONS,
        start,
        count,
        loadMore
    };
};

export const getReservationsSucceeded = ({bookings, bundles}, loadMore) => {
    return {
        type: actionTypes.GET_RESERVATIONS_SUCCEEDED,
        bookings,
        bundles,
        loadMore
    };
};

export const getReservationsFailed = (err) => {
    return {
        type: actionTypes.GET_RESERVATIONS_FAILED,
        err
    };
};

export const getPastReservations = (start, count, loadMore) => {
    return {
        type: actionTypes.GET_PAST_RESERVATIONS,
        start,
        count,
        loadMore
    };
};

export const getPastReservationsSucceeded = ({bookings, bundles}, loadMore) => {
    return {
        type: actionTypes.GET_PAST_RESERVATIONS_SUCCEEDED,
        bookings,
        bundles,
        loadMore
    };
};

export const getPastReservationsFailed = (err) => {
    return {
        type: actionTypes.GET_PAST_RESERVATIONS_FAILED,
        err
    };
};

export const getReservationDetails = ({id, type, next}) => ({
    type: actionTypes.GET_RESERVATION_DETAILS,
    options: {
        id,
        type,
        next
    }
});

export const getReservationDetailsSucceeded = details => ({
    type: actionTypes.GET_RESERVATION_DETAILS_SUCCEEDED,
    details
});

export const getReservationDetailsFailed = err => ({
    type: actionTypes.GET_RESERVATION_DETAILS_FAILED,
    err
});

export const cancelBooking = (id, allDays = false) => {
    return {
        type: actionTypes.CANCEL_BOOKING,
        id,
        allDays
    };
};

export const cancelBookingSucceeded = (id) => {
    return {
        type: actionTypes.CANCEL_BOOKING_SUCCEEDED,
        id
    }
};